import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { useToggle } from '@/src/hooks/useToggle';

import LibraryManageAccessList from './LibraryManageAccessList';

interface MenuItem {
  id: string;
  label: string;
  icon: string;
  class: string;
}

interface RootFolderProps {
  isActive: boolean;
  isEditor: boolean;
  menuItem: MenuItem;
  rowIndex: number;
  onHandleClick: () => void;
  isDropDisabled?: boolean;
  isDragDisabled?: boolean;
}

const RootFolder = ({
  isActive,
  isEditor,
  menuItem,
  rowIndex,
  onHandleClick,
  isDropDisabled,
  isDragDisabled,
}: RootFolderProps) => {
  const dispatch = useDispatch();
  const [isModalOpen, toggleIsModalOpen] = useToggle(false);
  const droppableId = menuItem.id;
  const draggableId = menuItem.id;

  const handleClickManageAccess = () => {
    dispatch({ type: 'UPDATE_FILES_ACTION_ITEM', action: 'accessInLibrary' });
    toggleIsModalOpen();
  };

  return (
    <React.Fragment>
      <Droppable droppableId={droppableId} isDropDisabled={!!isDropDisabled}>
        {(provided, snapshot) => (
          <div
            className={`droppableContainer ${snapshot.isDraggingOver ? 'itemDragging' : ''}`}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            <Draggable
              key={`default-library`}
              draggableId={draggableId}
              index={rowIndex}
              isDragDisabled={!!isDragDisabled}
            >
              {(provided) => (
                <div
                  className="sidebarDraggable"
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                >
                  <a
                    onClick={onHandleClick}
                    className={`${menuItem.class} ${isActive ? 'active' : ''}`}
                  >
                    <div className="menu-content">
                      <i className="material-icons">{menuItem.icon}</i>
                      <span>{menuItem.label}</span>
                    </div>

                    {isEditor && (
                      <a
                        className="accessListBtn"
                        data-tooltip-id="sidebar_access"
                        onClick={handleClickManageAccess}
                      >
                        <i className="material-icons mr0">people_outline</i>
                        <Tooltip id="sidebar_access" place="right" effect="solid">
                          Manage Access List
                        </Tooltip>
                      </a>
                    )}
                  </a>
                </div>
              )}
            </Draggable>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      {isModalOpen && <LibraryManageAccessList onClose={() => toggleIsModalOpen(false)} />}
    </React.Fragment>
  );
};

export default RootFolder;
